// Ziyaretci dilinde panelden girilmis chatbot adi; yoksa bos doner ve cagiran mevcut chatbotName/hazir ada duser.
function localizedChatbotName(settings, locale) {
    const content = ((((settings || {}).webchat || {}).chatbotNameByLanguage || {}).languageContent) || [];
    const entry = content.find((x) => x && x.languageCode === locale && String(x.text || "").trim());
    return entry ? String(entry.text).trim() : "";
}

module.exports = { localizedChatbotName };



// WEBPACK FOOTER //
// ./src/utils/chatbotName.js